import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { Flex } from 'Components/UI'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled(Flex)
  .attrs({
    width: 1,
    justifyContent: 'center',
  })
  .withConfig({ shouldForwardProp })`
  align-items: center;
  flex-direction: column;
  position: relative;
  color: ${themeGet('colors.white')};
`

export const Content = styled(Flex)`
  width: 100%;
  align-items: flex-start;
  flex-direction: column;
`
